import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Calendar } from 'primereact/calendar';

import LabelName from 'components/UI/LabelName/LabelName';
import { RequiredValidation } from 'components/UI/RequiredValidation/RequiredValidation';
import SubText from '../FormComponenets/SubText';
import { formatDOB, parseDOB } from 'modules/lead/helpers/helpers';
import { Dropdown } from 'primereact/dropdown';

export default function DateWithoutTimezoneField({
  index,
  handleSettingsClick,
  item = {},
  isFormBuilder,
  relationFieldName,
  isRelation = false,
  isFromPreview = false,
}) {
  const {
    control,
    formState: { errors },
    setValue,
  } = useFormContext();
  const { res_type, required, subtext, dateFormat, label = 'Date' } = item || {};
  const _label = res_type === 'custom-field' ? item?.name : label;

  const name = isRelation ? relationFieldName : item?.field_name || `form_data.${index}.value`;

  // Get current year dynamically
  const currentYear = new Date().getFullYear();
  const yearRange = `1900:${currentYear}`;

  const yearNavigatorTemplate = (e) => {
    // Sort options in descending order (newest to oldest)
    const sortedOptions = [...e.options].sort((a, b) => b.value - a.value);

    return (
      <Dropdown
        value={e.value}
        options={sortedOptions}
        onChange={(event) => e.onChange(event.originalEvent, event.value)}
        className="p-ml-2"
        style={{ lineHeight: 1 }}
      />
    );
  };

  const monthNavigatorTemplate = (e) => {
    return (
      <Dropdown
        value={e.value}
        options={e.options}
        onChange={(event) => e.onChange(event.originalEvent, event.value)}
        style={{ lineHeight: 1 }}
      />
    );
  };

  return (
    <div className="w-100">
      <LabelName>
        {_label}
        {required && <span className="danger-text"> *</span>}
      </LabelName>
      <div className="d-flex align-items-center flex-wrap w-100">
        <Controller
          name={name}
          control={control}
          rules={isFormBuilder ? {} : { required: required ? 'Required Field' : false }}
          render={({ field }) => (
            <Calendar
              id={field.name}
              value={parseDOB(field.value)}
              onChange={(e) => {
                field.onChange(formatDOB(e.value));
                if (item?.field_name && !isRelation) {
                  setValue(`form_data.${index}.value`, formatDOB(e.value));
                }
              }}
              placeholder="Select"
              dateFormat={dateFormat}
              monthNavigator
              yearNavigator
              yearRange={yearRange}
              yearNavigatorTemplate={yearNavigatorTemplate}
              monthNavigatorTemplate={monthNavigatorTemplate}
              className="input-shadow w-100"
              style={{ pointerEvents: isFormBuilder || isFromPreview ? 'none' : 'auto' }}
              inputRef={isFormBuilder ? null : field.ref}
            />
          )}
        />
        <SubText {...{ subtext, handleSettingsClick, item, isFormBuilder }} />
      </div>
      <RequiredValidation field={name} errors={errors} />
    </div>
  );
}
